import { useState, useEffect } from "react";
import { Card, CardBody, CardTitle, CardText, Collapse } from "reactstrap";

import "../styles/DownloadCard.css";

import Aos from "aos";
import "aos/dist/aos.css";

const DownloadCard = ({ title, text, downloadTitle, downloadLinks, image }) => {
  const [collapse, setCollapse] = useState(false);
  const toggle = () => setCollapse(!collapse);

  useEffect(() => {
    Aos.init({ duration: 1000, once: true });
  }, []);

  return (
    <Card className="download-card" data-aos="fade-in">
      {image && (
        <div className="download-card-image-container">
          <img src={image} alt={title} className="download-card-image" />
        </div>
      )}
      <CardBody className="download-card-body">
        <CardTitle className="download-card-title" tag="h5">
          {title}
        </CardTitle>
        {text && <CardText className="download-card-text">{text}</CardText>}
        <div>
          <div className="download-card-footer" onClick={toggle}>
            <span className="download-card-link">{downloadTitle}</span>
            <i className={`bi bi-${collapse ? "dash" : "plus"}-circle-fill download-card-icon`} aria-hidden="true"></i>
          </div>

          <Collapse isOpen={collapse}>
            <Card className="download-card-content">
              <CardBody className="download-card-content-body">
                <ul className="download-card-links">
                  {downloadLinks.map((link, index) => (
                    <li key={index}>
                      <a
                        href={link.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="download-card-link"
                      >
                        {link.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </CardBody>
            </Card>
          </Collapse>
        </div>
      </CardBody>
    </Card>
  );
};
export default DownloadCard;
